import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { INutrientLivestockPlanAnimal } from './nutrient-livestock-plan-animal.model';

@Injectable()
export class NutrientLivestockPlanAnimalService {
  constructor(private apiService: ApiService) {}

  saveLivestockPlanAnimals(
    nutrientPlanGroupId: number,
    nutrientLivestockPlanAnimals: INutrientLivestockPlanAnimal[]
  ): Promise<any> {
    if (nutrientLivestockPlanAnimals.length === 0) return Promise.resolve();
    return this.apiService.post('v1/nutrient-livestock-plan-animals', {
      nutrientPlanGroupId,
      nutrientLivestockPlanAnimals
    });
  }
}
